<template>
    <div class="detail">
        <div class="detail-i" style="margin-top: 56px;">
            <div class="detail-title">微信小程序审核配置</div>
            <div class="detail-con">
                <forms ref="formListDetail" :list="formList1" :value="formData" labelWidth="150px"></forms>
            </div>
        </div>
        
        <div class="btns">
            <el-button type="primary" @click="submitData">确认提交</el-button>
        </div>
        
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {parseTimeS} from '../../../utils/index'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { ZhiYe,ShenGao,TiZhong,Age,Education,Income,Marital,MaritalType,Constellation,FamilyBackground,Maritalyq,Houseyq,Jsdfxh,Carqk,Houseqk } from '../../../assets/data/data.json';
const isList = [
    { label: '关闭', value: false },
    { label: '开启', value: true }
]
export default {
    name: 'person',
    components:{
        queryCondition,
        forms,
        ElImageViewer
    },
    watch: {
    },
    data () {
        return {
            formData:{},
            formList1:[
                {type: "input",label: "微信小程序版本:",name: "version"},
                {type: "select",label: "苹果套餐展示:",name: "pgcz",options:isList},
                {type: "select",label: "注销按钮:",name: "cancel",options:isList},
                {type: "select",label: "审核模式:",name: "sudith",options:isList},
            ],
        }
    },
    created(){
    },
    mounted(){
        this.getDetail();
    },
    methods:{
        async getDetail(){
            let res  = await api.getMiniConfig();
            this.formData = res.data.data
        },
        async submitData(){
            let res  = await api.UpMiniConfig(this.formData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '修改成功'
                })
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
.detail{
    padding-top: 10px;
}
.item{
    display: flex;
    align-items: center;
}
.detail-title{
    height: 50px;
    display: flex;
    align-items: center;
    font-size: 20px;
    padding-left: 15px;
}
.content{
    display: flex;
    flex-wrap: wrap;
}
.detail-i{
    background-color: #ffffff;
    margin-top: 10px;
}
.btns{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 15px;
}
</style>
